import { ArrowUpRight, Copy } from "lucide-react";
import { useState } from "react";

export const DataCard = ({ width, myData = "N/A" }) => {
  return (
    <div
      className={`w-[${width}] h-[45px] flex items-center pl-[10px] bg-[#FFFFFF] truncate text-[#222222] text-[14px] font-normal`}
    >
      {myData}
    </div>
  );
};

export const CopyDataCard = ({ width = "100%", myData = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(myData);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div
      className={`w-[${width}] h-[45px] flex items-center pl-[10px] bg-[#FFFFFF] justify-between px-4 py-2`}
    >
      <span className="text-[#222222] text-[14px] font-normal truncate">
        {myData}
      </span>
      <div className="flex items-center gap-2">
        {copied && (
          <span className="text-green-600 text-sm font-medium">Copied!</span>
        )}
        <Copy
          className="w-4 h-4 text-gray-600 cursor-pointer hover:text-black"
          onClick={handleCopy}
        />
      </div>
    </div>
  );
};

export const CopyDataLocation = ({ width = "100%", myData = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(myData);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div
      className={`w-[${width}] h-[45px] flex items-center border border-[#000000] pl-[10px] pr-[2px] bg-[#FFFFFF] flex justify-between items-center py-2`}
    >
      <span className="text-[#222222] text-[14px] font-normal truncate">
        {myData}
      </span>
      <div className="flex items-center gap-[10px]">
        {copied && (
          <span className="text-green-600 text-sm font-medium">Copied!</span>
        )}
        <Copy
          className="text-gray-600 cursor-pointer hover:text-black"
          onClick={handleCopy}
        />
        <div
          className="h-[40px] w-[40px] bg-[#222222] rounded-[8px] cursor-pointer flex items-center justify-center"
          onClick={() =>
            window.open(`https://www.google.com/maps?q=${myData}`, "_blank")
          }
        >
          <ArrowUpRight size={22} color="#ffffff" />
        </div>
      </div>
    </div>
  );
};
